import { initialState, CitiesState } from './selectors';
import * as actions from './actions';

export default (
  state: CitiesState = initialState,
  action: actions.CitiesAction,
) => {
  switch (action.type) {
    case actions.CITIES_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.CITIES_ACTIONS.SUCCEEDED: {
      const {
        payload: { cities, region },
      } = action as actions.CitiesSucceeded;
      return { ...state, cities, region, loading: false };
    }

    case actions.CITIES_ACTIONS.FAILED: {
      const { error } = action as actions.CitiesFailed;
      return { ...state, error, loading: false };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Cities/services/reducer.ts